import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  getAllClients,
  getEnvComparisonList,
} from "../../apis/createEnvApi/createEnvApi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ConfirmKeyvaultMigrate from "../../components/ConfirmKeyvaultMigrate/ConfirmKeyvaultMigrate";

import CircularProgress from "@mui/material/CircularProgress";

const KeyVaultMigration = () => {
  const navigate = useNavigate();
  const [selectEnvStage, setSelectEnvStage] = useState(false);
  const [clientList, setClientList] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [selectedSourceEnv, setSelectedSourceEnv] = useState<any>();
  const [comparisonEnv, setComparisonEnv] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );
  const ActiveEnv = ActiveClient.Env_Data[0];

  const handleSelectedClient = (client: any) => {
    setSelectedClient(client);
  };
  const handleCompareEnv = () => {
    getEnvComparisonConfigs();
  };

  async function getEnvComparisonConfigs() {
    setIsLoading(true);
    let payload = {
      FirstClient_Id: selectedClient.Client_Id,
      FirstEnv_Id: selectedSourceEnv.Env_Id,
      FirstEnv_Name: selectedSourceEnv.Env_Name,
      SecondClient_Id: ActiveClient.Client_Id,
      SecondEnv_Id: ActiveEnv.Env_Id,
      SecondEnv_Name: ActiveEnv.Env_Name,
    };
    await getEnvComparisonList(payload, (resp: any) => {
      if (resp) {
        const normalizeData = (unstructuredData: any) => {
          const differentKeys = Object.entries(unstructuredData.different).map(
            ([key, value]: [string, any]) => ({
              key: key,
              value: value.firstEnv,
              prevValue: value.secondEnv,
            })
          );
          const uniqueKeys = unstructuredData.unique.firstEnv.map(
            (item: any) => ({
              key: item.KeyName,
              value: item.KeyValue,
              prevValue: "",
            })
          );

          return [...differentKeys, ...uniqueKeys].slice(0, 10);
        };
        const normalizedData = normalizeData(resp.data);
        const defaultValues = normalizedData.reduce((acc, curr) => {
          acc[`${curr.key}_value`] = curr.value;
          acc[`${curr.key}_checked`] = true;
          return acc;
        }, {});
        setComparisonEnv({ normalizedData, defaultValues });
        setSelectEnvStage(true);
      } else {
        // navigate("/errorInvalid");
      }
    });
    setIsLoading(false);
  }

  useEffect(() => {
    if (ActiveClient.Client_Id === 1000) {
      navigate("/switchClient");
    } else {
      getAllClients(EmpId, (res: any) => {
        setClientList(res);
      });
    }
  }, [ActiveClient.Client_Id]);
  return (
    <div className="tab-page-layout-1">
      <Box sx={{ padding: 3 }}>
        {!selectEnvStage ? (
          <>
            <Box height={"100%"}>
              <Typography variant="h5" textAlign={"center"} fontWeight={600}>
                Select Source Environment
              </Typography>
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={10}
              >
                <div className="input-div modal-1-input-div">
                  <label className="floating-label" htmlFor="client-name-input">
                    Client Name
                  </label>
                  <Select
                    labelId="artifact-label"
                    id="artifact"
                    className="input-field-1 env-multiselect"
                    onChange={(e) => handleSelectedClient(e.target.value)}
                  >
                    {clientList?.map((name: any, index: any) => (
                      <MenuItem value={name} key={index}>
                        {name?.Client_Name}-{name?.Client_Id}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="input-div modal-1-input-div">
                  <label className="floating-label" htmlFor="client-name-input">
                    Environment Name
                  </label>
                  <Select
                    labelId="artifact-label"
                    id="artifact"
                    className="input-field-1 env-multiselect"
                    onChange={(e) => setSelectedSourceEnv(e.target.value)}
                  >
                    {selectedClient?.Env_Data?.map((name: any, index: any) => (
                      <MenuItem value={name} key={index}>
                        {name?.Env_Name}-{name?.Env_Id}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </Box>
              <Box className="model-1-form-actions center-div">
                <button
                  className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                  type="button"
                  disabled={!selectedSourceEnv || isLoading}
                  onClick={handleCompareEnv}
                >
                  {isLoading ? (
                    <Box display={"flex"} alignItems={"center"}>
                      Done <CircularProgress color="inherit" size={20} />
                    </Box>
                  ) : (
                    <Box>
                      Done
                    </Box>
                  )}
                </button>
              </Box>
            </Box>
          </>
        ) : (
          <ConfirmKeyvaultMigrate
            data={comparisonEnv}
            Env_Id={ActiveEnv.Env_Id}
            Env_Name={ActiveEnv.Env_Name}
            Client_Id={ActiveClient.Client_Id}
            Emp_Id={EmpId}
          />
        )}
      </Box>
    </div>
  );
};

export default KeyVaultMigration;
